<template>
    <div id="services">
        <section class="awesome-feature-area bg-white section_padding_0_50 clearfix" id="features">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="section-heading text-center">
                            <h2>{{ $t('איך אנחנו יכולים לעזור?') }}</h2>
                            <div class="line-shape"></div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-6 col-lg-4 clickable-servvice">
                        <div class="single-feature" data-aos="fade-up" data-aos-duration="1200">
                            <i class="fas fa-magic pl-3"></i>
                            <h5>{{ $t('נכנס רעיון, יצא מוצר') }}</h5>
                            <p><span class="font-weight-bold">{{ $t('אפיון, עיצוב ופיתוח מערכות MVP') }} </span>{{ $t('(או MWP 😉) הוא מה שאנחנו הכי אוהבים לעשות, אנחנו נפתח בדיוק ובמהרה את הרעיון שיש לכם בראש.') }}</p>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 clickable-servvice">
                        <div class="single-feature" data-aos="fade-up" data-aos-duration="1200">
                            <i class="fas fa-mobile pl-3"></i>
                            <h5>{{ $t('תפור לכם') }}</h5>
                            <p>{{ $t('עזבו הגדרות, מוזמנים לנסות אותנו עם') }} <span class="font-weight-bold">{{ $t('כל מערכת, מורכבת ככל שתהיה') }}</span>{{ $t('. עיצוב ממש מורכב? טכנולוגיה מתקדמת במיוחד? שירות הפיתוח שלנו יחזיר לכם מוצר מהפנט.') }} </p>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 clickable-servvice">
                        <div class="single-feature" data-aos="fade-up" data-aos-duration="1200">
                            <i class="fas fa-handshake pl-3"></i>
                            <h5>{{ $t('צריכים יד?') }}</h5>
                            <p><span class="font-weight-bold">{{ $t('שירות פרילאנסרינג') }}</span> {{ $t('מקצועי, חדשני ומאורגן יהווה פתרון אופטימלי ל"פרונטאנד" או ה"באקאנד" בפרויקט שכ"כ חשוב לכם.') }}</p>
                        </div>
                    </div>
                </div>
                <button name="contact-us"
                        class="btn mb10 mt-3 to-contact mx-auto d-block"
                        v-scroll-to="'#contact-us'"
                        data-aos="fade-up" data-aos-duration="1200"
                >{{ $t('לקביעת פגישת ייעוץ') }}</button>
            </div>
        </section>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'services',
        computed: {
                ...mapGetters({
                    mobile: 'layout/mobile',
                }),
    },
    methods: {
    ...mapActions({
            updateModalTitle: 'layout/updateModalTitle',
            updateModalVisibility: 'layout/updateModalVisibility',
            updateModalContent: 'layout/updateModalContent',
        }),
                onSrviceClick(title,content){
            this.updateModalTitle({
                payload: {
                    title: title,
                },
            });
            this.updateModalContent({
                payload: {
                    content: content,
                },
            });
            this.updateModalVisibility({});
        },
    },
    }
</script>

<style lang="css" scoped>
    .section_padding_0_50 {
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .section-heading {
        margin-bottom: 60px;
    }
    .section-heading > h2 {
        font-weight: 300;
        color: #000;
        font-size: 48px;
        margin: 0;
    }
    .line-shape {
        margin-left: calc(50% - 40px);
    }
    .single-feature {
        padding: 20px 10px;
    }
    .clickable-servvice{
        border: 1px solid transparent;
        border-radius: 40px 40px 40px 40px;
        -webkit-transition-duration: 600ms;
        -o-transition-duration: 600ms;
        transition-duration: 600ms;
    }
    .clickable-servvice:hover {
        border-color: #eff2f6;
        -webkit-box-shadow: 0 10px 90px rgba(0, 0, 0, 0.08);
        box-shadow: 0 10px 90px rgba(0, 0, 0, 0.08);
        background-color: #fff;
    }

    .single-feature > i {
        color: #bf35d0;
        font-size: 30px;
        display: inline-block;
        float: right;
        margin-right: 10px;
    }
    .single-feature > h5 {
        font-size: 22px;
        color: #000;
    }
    .single-feature > p {
        margin-top: 15px;
    }
    button.to-contact {
        background: linear-gradient(144deg, #7719b4 10%, #bf35d0 65%);
        height: 48px;
        min-width: 185px;
        color: #ffffff;
        font-weight: 500;
        border-radius: 22px 25px 22px 22px;
        cursor: pointer;
    }

    @media (max-width: 767px) and (min-width: 320px){
        .section-heading > h2 {
            font-size: 32px;
        }
    }
    .straightRight{
        left:30px;
    }
    .straightLeft{
        right:30px;
    }
</style>
